import ChallengeTypeVideo from './ChallengeTypeVideo';

export default ChallengeTypeVideo;
